<template lang="html">
	<div class="column">
		<!-- <div class="sub-nav patrimonial-short row" :class="{ 'white': white }">
			<div class="item row">
				<div class="label">Montant investi</div>
				<div class="value">{{investmentStats.amount_invested|format_currency('€')}}</div>
			</div>
			<div class="item row">
				<div class="label">Mes avoirs</div>
				<div class="value">{{investmentStats.my_assets|format_currency('€')}}</div>
			</div>
			<div class="item row">
				<div class="label">Performance globale</div>
				<div class="value">{{global_performance|format_performance}}%</div>
				<div class="icon">
					<img v-if="investmentStats.global_performance >= 0" :src="good" alt="">
					<img v-else :src="bad" alt="">
				</div>
			</div>
		</div> -->
		<div class="anonymous-short" v-if="isAnonymous">
			Vous êtes en mode anonyme, vous ne pouvez pas accéder à toute les fonctionnalités
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Good from '@/assets/img/high-icon.svg'
import Bad from '@/assets/img/down-icon.svg'
import DjangoResource from '@/common/resources/Django'

export default {
	name: 'PatrimonialShort',
	props: ['white'],
	computed: {
		...mapGetters({
			isAnonymous: 'isAnonymous',
			investmentStats: 'investmentStats'
		})
	},
	data () {
		return {
			good: Good,
			bad: Bad,
			global_performance: 0,
		}
	},
	filters: {
		format_currency (value, symbol) {
			return value.toLocaleString() + ' ' + symbol
		},
		format_performance (value) {
			if (value === 0) {
				return value
			}

			return value > 0 ? ('+' + value.toLocaleString()) : value.toLocaleString()
		}
	},
	mounted () {
		DjangoResource.getUserPerformance(this.$store.state.users.id).then((data) => {
			this.global_performance = data.global_performance;
		})
	}
}
</script>

<style lang="scss" scoped>
.column {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/PatrimonialShort.vue